<template>
  <div class="common-panel-container">
    <docs-sidebar-container
      ref="docsSidebar"
    ></docs-sidebar-container>
    <common-panel-view
      :is-authorized="isAuthorized"
      :profile-name="profileName"
      :doc-name="docName"

      @login="$emit('login')"
      @logout="$emit('logout')"

      @open-menu="openMenu"
      @rename="rename"
    ></common-panel-view>
    <doc-name-dialog
      ref="dialog"
      v-model="currentDocName"
      @confirm="performRename"
    ></doc-name-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    CommonPanelView: require('./CommonPanelView.vue'),
    DocNameDialog: require('./DocNameDialog.vue'),
    DocsSidebarContainer: require('@/components/DocsSidebarContainer.vue')
  },
  data () {
    return {
      renameStatus: false,
      currentDocName: '',
      menuActive: false
    }
  },
  computed: {
    ...mapState({
      isAuthorized: state => state.isAuthorized,
      profileName: state => state.profileName,
      docName: state => state.docName
    })
  },
  methods: {
    ...mapActions(['renameDoc']),
    rename () {
      this.currentDocName = this.docName
      this.renameStatus = true
      this.$refs.dialog.open()
    },
    performRename () {
      this.renameDoc({oldDocName: this.docName, newDocName: this.currentDocName})
    },
    openMenu () {
      this.$refs.docsSidebar.open()
    }
  }
}
</script>

<style lang="sass"></style>


// WEBPACK FOOTER //
// CommonPanelContainer.vue?d1abfb40